// Copyright (c) 2018 Comsearch, Inc., All rights reserved

// find the segment end radio modulation configuration by its id in radioModulationConfigurations
// NOTE: segmentEndRadioModulationId and segmentEndModulationId mean effectively the same thing
// but are from different entities
// if there's no match, return empty values
const getModulationConfig = (radioModulationConfigurations, segmentEndModulationId) => (
  radioModulationConfigurations.find(d => d.segmentEndRadioModulationId === segmentEndModulationId) ||
  {
    power: '',
    radioModulationId: null,
  }
)

export default getModulationConfig
